// @ ACL Module Routes
export default [
  // ** Roles
  // ** Manage User Roles
  // {
  //     path: "/customer/payments",
  //     name: "customer.payments",
  //     component: () => import("@/views/customers/CustomerPayments.vue"),
  //     meta: {
  //         pageTitle: "Payments",
  //         breadcrumb: [
  //             {
  //                 text: "Payments",
  //                 active: true,
  //             },
  //         ],
  //         rule: "editor",
  //         requiresAuth: true,
  //     },
  // },
  {
    path: "/customer/complains",
    name: "customer.complains",
    component: () => import("@/views/customers/CustomerComplains.vue"),
    meta: {
      pageTitle: "Complain Management",
      breadcrumb: [
        {
          text: "Complain Management",
          active: true,
        },
      ],
      rule: "editor",
      requiresAuth: true,
    },
  },
];
